var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.listTitle } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "4", lg: "2", xl: "1" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        attrs: { disabled: _vm.activateSpinner },
                        on: {
                          click: function ($event) {
                            return _vm.onRefresh()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-rotate-right fs-14px",
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.rfrsh")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "justify-content-center mb-5" },
              [
                _c("security-list", {
                  key: _vm.refreshKey,
                  attrs: {
                    typeList: "configurationSSL",
                    spinnerActivated: _vm.activateSpinner,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }